"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shadows = require("../../../../styles/shadows");

var _colors = require("../../../../styles/colors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    background-color: #01b6f5;\n    border: 1px solid #01b6f5;\n    color: white;\n    padding: 0 1rem;\n    text-align: center;\n    vertical-align: middle;\n    transition: border 0.15s linear;\n    align-items: center;\n    display: inline-flex;\n    font-size: 1rem;\n    justify-content: center;\n    position: relative;\n    background-clip: border-box;\n    border-radius: 100px;\n    line-height: 2.375rem;\n    text-decoration: none;\n    cursor: pointer;\n    white-space: normal;\n    user-select: none;\n\n    &:focus {\n        outline: 0;\n        box-shadow: ", ";\n    }\n\n    &:active {\n        color: ", ";\n        transform: scale(0.95);\n        transition: all 0.2s ease;\n        text-decoration: none;\n    }\n\n    &:hover,\n    &:focus,\n    &:active {\n        background-color: ", ";\n        border-color: ", ";\n        color: ", ";\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledUploadFileLabel = _styledComponents["default"].label(_templateObject(), _shadows.SHADOW_OUTLINE, _colors.COLOR_BRAND_ACTIVE, _colors.COLOR_BRAND_ACTIVE, _colors.COLOR_BRAND_ACTIVE, _colors.COLOR_WHITE);

var _default = StyledUploadFileLabel;
exports["default"] = _default;